import type { TOC } from "@ember/component/template-only";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import colors, { type Color } from "glesys-controlpanel/helpers/colors";

export interface BadgeSignature {
  Args: {
    text: string;
    color?: Color;
  };
  Element: HTMLSpanElement;
}

const Badge: TOC<BadgeSignature> = <template>
  <span class="text-xs px-1 leading-none py-1 rounded-sm {{colors @color}}" {{mergeClasses}} ...attributes>
    {{@text}}
  </span>
</template>;

export default Badge;
